import { render, staticRenderFns } from "./yssj.vue?vue&type=template&id=db0717ae&scoped=true&"
import script from "./yssj.vue?vue&type=script&lang=js&"
export * from "./yssj.vue?vue&type=script&lang=js&"
import style0 from "./yssj.vue?vue&type=style&index=0&id=db0717ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db0717ae",
  null
  
)

export default component.exports